import { Button, Skeleton, Space, message } from "antd";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../../App.css";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const CONN_KEY = process.env.REACT_APP_NOT_SECRET_CODE_R;

const STATIC_FOOD_ITEMS = [
  { Catagory: "Food", product: "Kartof fre", price: "5.00" },
  { Catagory: "Food", product: "Marqarita Pizza", price: "20.00" },
  { Catagory: "Food", product: "Terevezli pendirli kanape", price: "15.00" },
  { Catagory: "Food", product: "Marqarita Pizza Böyük", price: "28.00" },
  { Catagory: "Food", product: "Pendir Seti", price: "50.00" },
  { Catagory: "Food", product: "Pendir Cubuqlari", price: "25.00" },
  { Catagory: "Food", product: "Saçaqlı Pendir", price: "15.00" },
  { Catagory: "Food", product: "Kartof Free Böyük", price: "16.00" },
  { Catagory: "Food", product: "Zeytun", price: "15.00" },
  { Catagory: "Food", product: "Ağ pendir", price: "15.00" },
  { Catagory: "Food", product: "VEGETERIAN PIZZA", price: "20.00" },
  { Catagory: "Food", product: "VEGETERIAN PIZZA BOYUK", price: "25.00" },
];

function Fakturas() {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const invoiceSectionRef = useRef(null);
  const { id } = useParams();
  const [permissions, setPermissions] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch permissions from session storage
    const storedPermissions = JSON.parse(localStorage.getItem('permissions'));
    console.log('Stored Permissions:', storedPermissions);

    if (storedPermissions && storedPermissions.length > 0) {
      setPermissions(storedPermissions[0]);
    }

    // Check if Menuaz permission is 0 and navigate if true
    if (storedPermissions && storedPermissions[0].Menuaz === 0) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fakturaUrl = `${CONN_KEY}menu.php`;
        const fakturaResponse = await axios.get(fakturaUrl);
        setData(fakturaResponse.data);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const handleDownload = async () => {
    const root = invoiceSectionRef.current;
    if (!root) return;

    const pages = Array.from(root.querySelectorAll(".page-menu"));
    if (!pages.length) {
      message.error("Səhifələr tapılmadı (.page-menu).");
      return;
    }

    // offscreen container
    const holder = document.createElement("div");
    holder.style.position = "fixed";
    holder.style.left = "-10000px";
    holder.style.top = "0";
    holder.style.width = "1200px";
    holder.style.background = "white";
    document.body.appendChild(holder);

    try {
      const pdf = new jsPDF("p", "pt", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      for (let i = 0; i < pages.length; i++) {
        holder.innerHTML = "";
        const clone = pages[i].cloneNode(true);
        holder.appendChild(clone);

        const canvas = await html2canvas(clone, {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          backgroundColor: "#000000",
          windowWidth: 1200,
        });

        const imgData = canvas.toDataURL("image/jpeg", 0.9);

        // A4-ə proporsional sığdır
        const imgW = canvas.width;
        const imgH = canvas.height;
        const ratio = Math.min(pageWidth / imgW, pageHeight / imgH);

        const renderW = imgW * ratio;
        const renderH = imgH * ratio;

        const x = (pageWidth - renderW) / 2;
        const y = (pageHeight - renderH) / 2;

        if (i > 0) pdf.addPage();
        pdf.addImage(imgData, "JPEG", x, y, renderW, renderH);
      }

      pdf.save("menu.pdf");
    } catch (e) {
      console.error(e);
      message.error("PDF yaratmaq alınmadı.");
    } finally {
      document.body.removeChild(holder);
    }
  };

  const normalizeProductKey = (value) =>
    (value || "").toString().trim().toLowerCase().replace(/\s+/g, " ");

  const formatPriceAzn = (value) => {
    const str = (value ?? "").toString().trim();
    if (!str) return str;
    if (/azn/i.test(str)) return str;
    if (/^\d+(\.\d+)?$/.test(str)) return `${str} azn`;
    return str;
  };

  const getItemsByCategory = (cat) =>
    Object.values(data)
      .filter((x) => x?.Catagory === cat)
      .sort((a, b) => {
        const na = (a.product || "").toLowerCase();
        const nb = (b.product || "").toLowerCase();
        if (na < nb) return -1;
        if (na > nb) return 1;
        return parseFloat(b.price || 0) - parseFloat(a.price || 0);
      });

  const getMergedItemsByCategory = (cat, extras = []) => {
    const map = new Map();

    for (const item of Object.values(data).filter((x) => x?.Catagory === cat)) {
      map.set(normalizeProductKey(item?.product), item);
    }

    // Extras override backend items with the same product name
    for (const item of extras.filter((x) => x?.Catagory === cat)) {
      map.set(normalizeProductKey(item?.product), item);
    }

    return Array.from(map.values()).sort((a, b) => {
      const na = (a.product || "").toLowerCase();
      const nb = (b.product || "").toLowerCase();
      if (na < nb) return -1;
      if (na > nb) return 1;
      return parseFloat(b.price || 0) - parseFloat(a.price || 0);
    });
  };
  const renderCategory = (cat) =>
    getItemsByCategory(cat).map((item) => (
      <div className="cardssdsVODKA" key={`${cat}-${item.product}`}>
        <p>{item.product}</p>
        <p>{item.price}</p>
      </div>
    ));
  console.log("isLoading:", isLoading);
  const items = Object.keys(data)
    .filter((key) => data[key].Catagory === "CATEGORY_NAME") // Replace CATEGORY_NAME with the actual category name
    .map((key) => data[key])
    .sort((a, b) => a.product.localeCompare(b.product)); // Sort items by product name

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <>
          <Space>
            {/* <Button onClick={handlePrint}>Print</Button> */}
            <Button onClick={handleDownload}>Pdf'i Yarat</Button>
          </Space>
          <div className="container">
            <div id="invoice-section" ref={invoiceSectionRef}>
              <div className="jjhgdf-menu-1 page-menu">
                <div className="djhvms">
                 
                  <div className="ssfsdb">
                    {/* Inside the "WHISKEY" category section: */}
                    <div className="ssfsdb">
                      {/* Inside the "WHISKEY" category section: */}
                      <div className="ssfsdb">
                        {Object.keys(data)
                          .filter((key) => data[key].Catagory === "WHISKEY")
                          .map((key) => data[key])
                          .sort((a, b) => {
                            const nameA = a.product.toLowerCase();
                            const nameB = b.product.toLowerCase();

                            if (nameA < nameB) return -1;
                            if (nameA > nameB) return 1;

                            // If names are the same, compare prices
                            const priceA = parseFloat(a.price);
                            const priceB = parseFloat(b.price);

                            return priceB - priceA;
                          })
                          .map((item) => (
                            <div className="cardssds" key={item.product}>
                              <p>{item.product}</p>
                              <p>{item.price}</p>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="jjhgdf-menu-2 page-menu">
                <div className="ssfsdbVOD" style={{ backdropFilter: 'blur(25px)' }}>
                  
                  {Object.keys(data)
                    .filter((key) => data[key].Catagory === "VODKA")
                    .map((key) => data[key])
                    .sort((a, b) => {
                      const nameA = a.product.toLowerCase();
                      const nameB = b.product.toLowerCase();

                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;

                      // If names are the same, compare prices
                      const priceA = parseFloat(a.price);
                      const priceB = parseFloat(b.price);

                      return priceB - priceA;
                    })
                    .map((item) => (
                      <div className="cardssdsVODKA" key={item.product}>
                        <p>{item.product}</p>
                        <p>{item.price}</p>
                      </div>
                    ))}
                </div>
              </div>
              <div className="jjhgdf-menu-3 page-menu">
                <div className="dhvsj">
                  <div className="ssfsdbWC">
                    <h1
                      className="dhjsfbs2"
                      style={{ top: "1322px", left: "285px" }}
                    >
                      COGNAC
                    </h1>
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "COGNAC")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsWİNE" key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                  </div>
                  <div className="ssfsdbWCH">
                    <h1
                      className="dhjsfbs2"
                      style={{ top: "1322px", left: "285px" }}
                    >
                      CHAMPAGNE
                    </h1>
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "CHAMPAGNE")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsCHAMPAGNE" key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="jjhgdf-menu-4 page-menu">
                <div className="dhvsjdfd">
                  <div className="ssfsdbTEQUILA">
                    <h1
                      className="dhjsfbs2"
                      style={{ top: "1322px", left: "285px" }}
                    >
                      TEQUILA
                    </h1>
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "TEQUILA")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsCHAMPAGNE" key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                  </div>
                  <div className="ssfsdbGIN">
                    <h1
                      className="dhjsfbs2"
                      style={{ top: "1322px", left: "285px" }}
                    >
                      GIN
                    </h1>
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "GIN")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsCHAMPAGNE" key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="jjhgdf-menu-5 page-menu">
                <div className="pageContent menu5Grid" >
                  {/* SOL: WINE */}
                  <section className="menuSection" style={{ gap: "10px" }}>
                    
                    <div className="menuList SADFGV" style={{ gap: "20px" }}>
                      {renderCategory("WİNE")}
                    </div>
                  </section>
                </div>
              </div>
              <div className="jjhgdf-menu-51 page-menu">
                <div className="pageContent menu5Grid" >
                  {/* SAĞ: VERMUT üst, APERETIV alt */}
                  <div className="rightStack" style={{ gap: "10px" }}>
                    <section className="menuSection ">
                      <h1 className="dhjsfbs2"
                        style={{ top: "1322px", left: "285px" }}>VERMUT</h1>
                      <div className="menuList SADFGV" style={{ gap: "10px" }}>
                        {renderCategory("VERMUT")}
                      </div>
                    </section>

                    <section className="menuSection" style={{ gap: "10px" }}>
                      <h1 className="dhjsfbs2"
                        style={{ top: "1322px", left: "285px" }}>APERETIV</h1>
                      <div className="menuList SADFGV" style={{ gap: "10px" }}>
                        {renderCategory("APERETIV")}
                      </div>
                    </section>
                  </div>
                </div>
              </div>
              <div className="jjhgdf-menu-6 page-menu">
                <div className="dhvsjdfg" style={{ marginTop: 75 }}>
                  <div className="SADFGV">
                    <h1
                      className="dhjsfbs2"
                      style={{ top: "1322px", left: "285px" }}
                    >
                      LIQUOR
                    </h1>
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "LIQUOR")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsVODKA" key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                  </div>
                  <div className="APERETIVasf">
                    <h1
                      className="dhjsfbs2"
                      style={{ top: "1322px", left: "285px" }}
                    >
                      ROM
                    </h1>
                    {Object.keys(data)
                      .filter((key) => data[key].Catagory === "ROM")
                      .map((key) => data[key])
                      .sort((a, b) => {
                        const nameA = a.product.toLowerCase();
                        const nameB = b.product.toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;

                        // If names are the same, compare prices
                        const priceA = parseFloat(a.price);
                        const priceB = parseFloat(b.price);

                        return priceB - priceA;
                      })
                      .map((item) => (
                        <div className="cardssdsVODKA" key={item.product}>
                          <p>{item.product}</p>
                          <p>{item.price}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="jjhgdf-menu-7 page-menu">
                <div className="dhvsjd" style={{ marginTop: 180 }}>
                  <div className="jkhgdfv">
                    <div className="SADFGV">
                      <h1
                        className="dhjsfbs2"
                        style={{ top: "1322px", left: "285px" }}
                      >
                        BEER
                      </h1>
                      {Object.keys(data)
                        .filter((key) => data[key].Catagory === "BEER")
                        .map((key) => data[key])
                        .sort((a, b) => {
                          const nameA = a.product.toLowerCase();
                          const nameB = b.product.toLowerCase();

                          if (nameA < nameB) return -1;
                          if (nameA > nameB) return 1;

                          // If names are the same, compare prices
                          const priceA = parseFloat(a.price);
                          const priceB = parseFloat(b.price);

                          return priceB - priceA;
                        })
                        .map((item) => (
                          <div className="cardssdsVODKA" key={item.product}>
                            <p>{item.product}</p>
                            <p>{item.price}</p>
                          </div>
                        ))}
                    </div>
                    <div className="APERETIVasft" style={{ marginTop: 50 }}>
                      <h1
                        className="dhjsfbs2"
                        style={{ top: "1322px", left: "285px" }}
                      >
                        SNACKS
                      </h1>
                      {Object.keys(data)
                        .filter((key) => data[key].Catagory === "SNACKS")
                        .map((key) => data[key])
                        .sort((a, b) => {
                          const nameA = a.product.toLowerCase();
                          const nameB = b.product.toLowerCase();

                          if (nameA < nameB) return -1;
                          if (nameA > nameB) return 1;

                          // If names are the same, compare prices
                          const priceA = parseFloat(a.price);
                          const priceB = parseFloat(b.price);

                          return priceB - priceA;
                        })
                        .map((item) => (
                          <div className="cardssdsVODKA" key={item.product}>
                            <p>{item.product}</p>
                            <p>{item.price}</p>
                          </div>
                        ))}
                    </div>
                    {/* <div className="ssfsagasdf">
                      <h1
                        className="dhjsfbs2"
                        style={{ top: "1322px", left: "285px" }}
                      >
                        TOBACCO
                      </h1>
                      {Object.keys(data)
                        .filter((key) => data[key].Catagory === "TOBACCO")
                        .map((key) => data[key])
                        .sort((a, b) => {
                          const nameA = a.product.toLowerCase();
                          const nameB = b.product.toLowerCase();

                          if (nameA < nameB) return -1;
                          if (nameA > nameB) return 1;

                          // If names are the same, compare prices
                          const priceA = parseFloat(a.price);
                          const priceB = parseFloat(b.price);

                          return priceB - priceA;
                        })
                        .map((item) => (
                          <div className="cardssdsVODKA" key={item.product}>
                            <p>{item.product}</p>
                            <p>{item.price}</p>
                          </div>
                        ))}
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="jjhgdf-menu-8 page-menu">
                <div className="ssfsdbVODs" style={{ marginTop: 60 }}>
                  
                  {Object.keys(data)
                    .filter((key) => data[key].Catagory === "COCKTAILS")
                    .map((key) => data[key])
                    .sort((a, b) => {
                      const nameA = a.product.toLowerCase();
                      const nameB = b.product.toLowerCase();

                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;

                      // If names are the same, compare prices
                      const priceA = parseFloat(a.price);
                      const priceB = parseFloat(b.price);

                      return priceB - priceA;
                    })
                    .map((item) => (
                      <div className="cardssdsVODKA" key={item.product}>
                        <p>{item.product}</p>
                        <p>{item.price}</p>
                      </div>
                    ))}
                </div>
              </div>
              <div className="jjhgdf-menu-Food page-menu">
                <div
                  className="ssfsdbVOD ssfsdbVOD--food"
                  style={{ top: "-579px" }}
                >
                  {getMergedItemsByCategory("Food", STATIC_FOOD_ITEMS).map(
                    (item) => (
                      <div
                        className="cardssdsVODKA"
                        key={`Food-${normalizeProductKey(item.product)}`}
                      >
                        <p>{item.product}</p>
                        <p>{formatPriceAzn(item.price)}</p>
                      </div>
                    )
                  )}
                </div>
              </div>
              <div className="jjhgdf-menu-9 page-menu">
                <div className="ssfsdbVOD" style={{ top: "-579px" }}>
                  
                  {Object.keys(data)
                    .filter((key) => data[key].Catagory === "SOFT DRINKS")
                    .map((key) => data[key])
                    .sort((a, b) => {
                      const nameA = a.product.toLowerCase();
                      const nameB = b.product.toLowerCase();

                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;

                      // If names are the same, compare prices
                      const priceA = parseFloat(a.price);
                      const priceB = parseFloat(b.price);

                      return priceB - priceA;
                    })
                    .map((item) => (
                      <div className="cardssdsVODKA" key={item.product}>
                        <p>{item.product}</p>
                        <p>{item.price}</p>
                      </div>
                    ))}
                </div>
              </div>
              <div className="jjhgdf-menu-10 page-menu">
                <div className="ssfsdbVOD">
                 
                  {Object.keys(data)
                    .filter((key) => data[key].Catagory === "VAPE")
                    .map((key) => data[key])
                    .sort((a, b) => {
                      const nameA = a.product.toLowerCase();
                      const nameB = b.product.toLowerCase();

                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;

                      // If names are the same, compare prices
                      const priceA = parseFloat(a.price);
                      const priceB = parseFloat(b.price);

                      return priceB - priceA;
                    })
                    .map((item) => (

                      <div className="cardssdsVODKA" key={item.product}>
                        <p>{item.product}</p>
                        <p>{item.price}</p>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Fakturas;
